import {
  Input,Output,SimpleChanges,OnChanges,DoCheck,ViewChild,
  EventEmitter,AfterViewInit,
  Component,
  OnInit
} from '@angular/core';
import {ElementRef} from '@angular/core';
import * as jMoment from 'jalali-moment';
import {SessionDateVM} from "../../../models/SessionDateVM.model";
import {DateUtilService} from "../../../services/date-service/DateUtilService";
import {OrderBagService} from "../../../services/orderbag/orderbag.service";
import {IntakeFormComponent} from "../../intake-form/intake-form.component";

declare var $: any;
var parent;
@Component({

  selector: 'rw-date-picker-v3',  // <home></home>

  styles: [require('./rw-date-picker.component.scss')],

  template: require('./rw-date-picker.component.html'),
})
export class RWDatePickerComponent implements OnInit,OnChanges,DoCheck,AfterViewInit {

  @Input()minDate:Date;
  public minDateM;
  any;
  @Input()maxDate:Date;
  @Input()availableDates:SessionDateVM[] ;
  @Input()selectedDate:Date;
  @Input()placeholderText:string='تاریخ';
  @Output()selectedDateChanged:EventEmitter<Date> = new EventEmitter();


  public tempDate:Date;
  public viewInited:boolean=false;
  public showCalendar:boolean=true;

  //OR if you have initial value you could use following code

  public dateObject:any = jMoment();
  public config:any;
  public configModal:any;

  public calendarDataObject : any;
  public currentMonthDate : any;
  public weekDayName : any = ["ش","ی","د","س","چ","پ","ج"];
  public isDataLoaded :boolean = false;

  @Input()
  public isModal:boolean=false;
  /**
   * TypeScript public modifiers
   */
  constructor(private dateUtilService: DateUtilService
              ) {

    parent = this;
    this.config = {

    };

  }

  public ngOnInit() {
    this.minDate = new Date();
    this.minDateM = jMoment('1399-08-22', 'jYYYY,jMM,jDD');
    // parent.updateCalendar();

  }


  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
    if(changes.availableDates)
    parent.updateCalendar();

  }
  ngAfterViewInit()
  {
   if(this.isModal)
    this.configModal = {

    };
    this.viewInited=true;

  }
  ngDoCheck() {
    // if (this.dateObject != this.tempDate) {
    //   this.tempDate = this.dateObject;
    //   this.dateObjectChanged(this.dateObject);
    // }
  }

  updateCalendar() {

    this.isDataLoaded = false;
    if(this.currentMonthDate == null)
      this.currentMonthDate = this.dateUtilService.jMomentFA();

    setTimeout(()=>{    //<<<---    using ()=> syntax
      this.makeCalendar(this.currentMonthDate);
    }, 300);

  }

 makeCalendar(initDate?) {

   var today = this.dateUtilService.jMomentFA(initDate);
   let firstDayOfMonth  = this.dateUtilService.firstDayOfCurrentMonth(today);
   // let dayNumberOFWeek = this.dateUtilService.dayOfWeek(firstDayOfMonth);
   let dayNumberOFWeek = this.dateUtilService.dayOfWeekPersian(firstDayOfMonth);
   let daysInMonth = today.daysInMonth();

    this.calendarDataObject = [];
    let i = 0 ;
    while (i < daysInMonth+dayNumberOFWeek) {


      let weekRow = [];
      for (let j = 0; j < 7; j++) {

        let day : any;
        day = {};
        day.date = firstDayOfMonth.clone();
        day.date = day.date.add(i-dayNumberOFWeek, 'days');
        day.disable = true;
        day.dayNo = i+1-dayNumberOFWeek;
        day.order = j;
        day.capacity = 0;

        if(i<dayNumberOFWeek) // first day of month
        {
            day.date = null;
            day.disable = true;
            day.dayNo = null;
        }
        if(i>=daysInMonth+dayNumberOFWeek)
        {
          day.date = null;
          day.disable = true;
          day.dayNo = null;
        }
        let temp = this.isSelectableDate(day.date);
        if(temp)
        {
          day.inList = true;
          day.disable = false;
          if(temp.capacity)
            day.capacity = temp.capacity;
        }
        else{
          day.inList = false;
        }

        day.selected = this.isDaySelected(day);

        weekRow.push(day);
        i++;
      }

      this.calendarDataObject.push(weekRow);
    }
  //   //$('.dp-calendar-nav-container-right').click();
  //   setTimeout(function(){
  //    parent.showCalendar=false;
  //     setTimeout(function(){
  //      parent.showCalendar=true;
  //     },1)
  //
  //   },1)
   this.isDataLoaded = true;
    return true;
  }
  noDayAvailable(date:any)
  {
    return false;
  }

  isDayDisabledCallback(date:any) {


    let isInList =parent.isInList(parent.availableDates,date);

    if (isInList)
    {
      return false;
    }
    else
      return true;


  }
  dayBtnCssClassCallback(date:any){

    let isInList =parent.isInList(parent.availableDates,date);
    if (isInList)
    {
      if( isInList.capacity<1)return 'is-full-date';
    }
    else
      return '';
  }

  public isSelectableDate(date:Date)
  {
    if(date)
    {
      let isInList =parent.isInList(parent.availableDates,date);
      return isInList;
    }
    return false;
  }

  public isInList(dateList:SessionDateVM[], date:Date):SessionDateVM {

    let isInList = null;
    if (dateList) {

      if(date && !date.getDate)
      date=this.convertMomentToDate(date);

      let isLogged = false;

      dateList.forEach((ado:SessionDateVM)=> {

        let ad=new Date( ado.startDate); /// not work on safari !!

        if(!this.isDateValid(ad))
          ad=new Date( ado.startDate.replace(/-/g, "/"));

        ad=this.correctTimeZone(ad);

        if (ad.getDate() == date.getDate() &&
          ad.getMonth() == date.getMonth() &&
          ad.getFullYear() == date.getFullYear()) {

          isInList = ado;
          return
        }
      });

    }
    return isInList;
  }

  public dateObjectChanged(dateObject:any):void {
    if (this.dateObjectIsValid(dateObject)) {
      this.selectedDate = this.convertMomentToDate(dateObject);

      this.selectedDateChanged.emit(this.selectedDate);
    }
    else {
      this.dateObject = null;
      this.selectedDate = null;
      this.selectedDateChanged.emit(null);
      // this.datePicker.api.open();
    }
  }

  public dateObjectIsValid(dateObject:any):boolean {
    if (dateObject) {
      if (dateObject.toDate()) {
        let item= this.isInList(this.availableDates, dateObject.toDate());
        if(item)
        return true;
        else
        return false;
        //  return !(this.isDayDisabledCallback(dateObject))

      }
    }
    return false;
  }

  public convertMomentToDate(dateObject:any):Date {
    let retDate:Date;
    retDate = dateObject.toDate();
    retDate.setHours(12, 0, 0);
    //retDate=this.correctTimeZone(retDate);
    return retDate;
  }

  public correctTimeZone(date:Date) {

    var aestTime = date.toLocaleString("en-US", {timeZone: "Asia/Tehran"});
    date = new Date(aestTime);

    //var n = date.getTimezoneOffset();
    date.setHours(12, 0, 0);

    return date;

  }


  public isDateValid(date){
    if (isNaN(date.getTime())) {

    }
    else {
      return true;
    }
  }

  public moveToDate(date)
  {
    this.currentMonthDate = this.dateUtilService.jMomentFA(new Date(date));
    this.updateCalendar();
  }

  public nextMonth()
  {
    this.currentMonthDate = this.dateUtilService.jMomentFA(this.currentMonthDate).add(1,'month');
    this.updateCalendar();
  }

  public prevMonth()
  {
    this.currentMonthDate = this.dateUtilService.jMomentFA(this.currentMonthDate).add(-1,'month');
    this.updateCalendar();
  }

  public setSelectedDate(dayObject)
  {
    if(dayObject.date && dayObject.disable == false) {
      this.clearSelectedDay();
      this.dateObjectChanged(dayObject.date);
      dayObject.selected = true;
    }
  }

  public clearSelectedDay(){
    this.calendarDataObject.forEach((co:any)=> {
      co.forEach((day:any)=> {
        if(day.selected)
          day.selected = false;
      })
    })
  }

  public isDaySelected(dayObject){


    if(dayObject.date && dayObject.disable == false && this.selectedDate) {

      let dayDate = new Date(dayObject.date);

      if (this.selectedDate.getDate() == dayDate.getDate() &&
        this.selectedDate.getMonth() == dayDate.getMonth() &&
        this.selectedDate.getFullYear() == dayDate.getFullYear()) {

        return true;
      }
    }

    return false;
  }

  public dayCssClass(day)
  {
    if(day.inList)
    {
      if(day.capacity<1)
      {
        return 'day-full' ;

      }
      else{
        return 'day-available' ;
      }
    }
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/rw-date-picker/rw-date-picker.component.ts